export default function normalizeNumber(value) {

    if (value) {

        // ignore , to acept 2,000 as 2000
        value = value.toString().replace(",","");

        value = parseInt(value);
        if (!isNaN(value)) {
            // console.log("  -->", value)
            return value;
        }
    }
    // console.log(" -->", null)
    return null;

}
